'use strict';

export default class SearchBar {
  constructor() {
    var $searchIcon = $('.js-search-bar__icon');
    var $searchForm = $('.js-search__form');
    const $searchMessage = $('.search__message');
    const $headerSearchIcon = $('.js-header__search__icon');
    const $headerSearchInput = $('.header__search__input');
    const $searchInput = $('.js-search-bar__input, .header__search__input');
    const $searchBtn = $('.js-search-bar__icon');
    const $activeSearchIcon = $('.active .js-header__search__icon');
    let submitSearch;


    if($searchForm) {
      $headerSearchInput.addClass('js-header__search__input');

      submitSearch = function($form){

          let searchTerm;
          searchTerm = $form.find('.js-search-bar__input').val().trim().replace(/\s+/g, '%20').toLowerCase();


          if( searchTerm ) {
            if(!$form.hasClass('header__search__form')){
              $searchMessage.fadeOut();
            }
            var searchDomain = "https://" + window.location.hostname + "/search-results/1?indexCatalogue=consult-australia-index&wordsMode=&orderBy=Relevance&searchQuery=";
            var searchURL = searchDomain + searchTerm;

            window.location.href= searchURL;
            return false;

          } else {
            if(!$(this).hasClass('header__search__form')){
              $searchMessage.fadeIn();
            }
          }
      }





    $headerSearchInput.on('focus', function(e){
      if($(window).width() > 980){
      $(this).parents('.js-search__form').addClass('active');


        $(this).parents('.header__end').addClass('active');
      }
    })

    $headerSearchInput.on('keydown', function(event){

      var e = event.which || event.keyCode;

      if(e === 9) {
        event.preventDefault();
        $('.js-header__search__icon').focus();
      }
    })

    $headerSearchInput.attr('tabindex','-1')

    $headerSearchInput.on('blur', function(e){
      console.log($(e.relatedTarget).hasClass('js-header__search__icon'))
      if(!$(e.relatedTarget).hasClass('js-header__search__icon')){
        $(this).parents('.js-search__form').removeClass('active');
        $(this).parents('.js-search__form').find('.js-search-bar__input').val('');
        $(this).parents('.header__end').removeClass('active');
      }
    })

    $searchInput.keypress(function (e) {
         var code = (e.keyCode ? e.keyCode : e.which);
         if(code == 13)  // the enter key code
          {
            e.preventDefault();
            submitSearch($(this).parents(".js-search__form"));
          }
    });

    $searchBtn.on('click', function(e){
      e.preventDefault();
      submitSearch($(this).parents(".js-search__form"));
    })



    $headerSearchIcon.on('blur', function(){
      $(this).parents('.js-search__form').removeClass('active');
      $(this).parents('.js-search__form').find('.js-search-bar__input').val('');
      $(this).parents('.header__end').removeClass('active');
    })

    $headerSearchIcon.on('click', function(e){
      e.preventDefault();
      if($(window).width() > 980){

        if($(this).parents('.active').length && $(this).parent().find('.js-search-bar__input').val().length){
            submitSearch($(this).parents(".js-search__form"));
        } else {
            $(this).parent().find('.js-search-bar__input').focus();
        }
      } else {
          submitSearch($(this).parents(".js-search__form"));
      }


    })


  }

  }
}
